import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MeanderRbRoutingModule } from './meander-rb-routing.module';
import { CollectionComponent } from './collection/collection.component';
import { DetailPageComponent } from './detail-page/detail-page.component';
import { RbTagsComponent } from './rb-tags/rb-tags.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AngularResizedEventModule } from 'angular-resize-event';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { MarkdownModule } from 'ngx-markdown';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { QuillModule } from 'ngx-quill';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DetailComponent } from './detail/detail.component';




@NgModule({
  declarations: [
    CollectionComponent,
    DetailPageComponent,
    RbTagsComponent,
    DetailComponent
  ],
  imports: [
    CommonModule,
    MeanderRbRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatchHeightModule,
    AngularResizedEventModule,
    NgSelectModule,
    NgbModule,
    SwiperModule,
    PipeModule,
    MatAutocompleteModule,
    MatChipsModule,
    MarkdownModule.forRoot(),
    QuillModule.forRoot(),
    NgxDatatableModule,
    NgxSpinnerModule,

  ]
})
export class MeanderRbModule { }
